export default __webpack_public_path__ + "static/media/137.8cd6884c.jpg";